/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

enum StatusPacs {
  PROJET = 'Projet',
  EN_COURS = 'En cours',
  DISSOUS = 'Dissous',
  IRRECEVABLE = 'Irrecevable',
}

export default StatusPacs;
